import { api } from 'app/utils/api/helpers'

export const getRenterAboutUs = () => {
  return api.get(`sm/aboutus`)
}

export const saveRenterAboutUs = (content: string) => {
  return api.post(`sm/aboutus`, { about: content })
}
